<template>
  <div class="main_data">
    <div class="main_header">
      <p>{{ $t('lang.k_048001') }}</p>
    </div>
    <vh-row type="flex" class="row-bg" justify="space-around">
      <vh-col :span="colSpan" v-if="titleType == 1">
        <div class="grid-content">
          <span>{{ $t('lang.k_048002') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">{{ $t('lang.k_048003') }}</div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.total"
              :duration="1500"
              v-if="mainKeyData.total >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType">
        <div class="grid-content">
          <span>{{ titleType == 1 ? $t('lang.k_048004') : '' }}{{ $t('lang.k_048005') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ titleType == 1 ? $t('lang.k_048006') : $t('lang.k_048007') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.total_live_time }}
            <!-- <count-to :startVal="0"
              :endVal="mainKeyData.total_live_time"
              :duration="1500"
              v-if="mainKeyData.total_live_time >= 0">
            </count-to> -->
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="!titleType">
        <div class="grid-content">
          <span>{{ $t('lang.k_048008') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048009') }}
              <br />
              {{ $t('lang.k_048010') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.webinar_count"
              :duration="1500"
              v-if="mainKeyData.webinar_count >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType != 4">
        <div class="grid-content">
          <span>{{ $t('lang.k_048011') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048012') }}
              <br />
              {{ $t('lang.k_048013') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.max_onlines"
              :duration="1500"
              v-if="mainKeyData.max_onlines >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan">
        <div class="grid-content">
          <span>{{ $t('lang.k_048014') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content" v-if="!titleType">
              {{ $t('lang.k_048015') }}
              <br />
              {{ $t('lang.k_048016') }}
            </div>
            <div slot="content" v-else>
              <!-- {{ titleType == 4 ? '点播' : '直播' }}创建至今，进入观看页面{{
                titleType == 4 ? '' : '（直播+回放）'
              }}的观看人数，以播放器sdk上报为准， -->
              {{ $t('lang.k_048017') }}
              <br />
              <!-- 用户真实观看了视频。筛选条件内同一个用户多次观看会进行去重 -->
              {{ $t('lang.k_048018') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.watch_number"
              :duration="1500"
              v-if="mainKeyData.watch_number >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType != 1">
        <div class="grid-content">
          <span>{{ $t('lang.k_048019') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content" v-if="titleType == 4">
              {{ $t('lang.k_048020') }}
            </div>
            <div slot="content" v-else>
              {{ $t('lang.k_048021') }}
              <br />
              {{ $t('lang.k_048022') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.watch_times"
              :duration="1500"
              v-if="mainKeyData.watch_times >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType == 1 && !['/data/info'].includes($route.path)">
        <div class="grid-content">
          <span>{{ $t('lang.k_048019') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048023') }}
              <br />
              {{ $t('lang.k_048024') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.watch_times"
              :duration="1500"
              v-if="mainKeyData.watch_times >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="!['/data/info'].includes($route.path)">
        <div class="grid-content">
          <span>{{ $t('lang.k_048025') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">{{ $t('lang.k_048026') }}</div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.watch_times_avg }}
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType == 1 && ['/data/info'].includes($route.path)">
        <div class="grid-content">
          <span>{{ $t('lang.k_048019') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048023') }}
              <br />
              {{ $t('lang.k_048024') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            <count-to
              :startVal="0"
              :endVal="mainKeyData.watch_times"
              :duration="1500"
              v-if="mainKeyData.watch_times >= 0"
            ></count-to>
          </h3>
        </div>
      </vh-col>
      <vh-col :span="4" v-if="['/data/info'].includes($route.path)">
        <div class="grid-content">
          <span>{{ $t('lang.k_048025') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">{{ $t('lang.k_048026') }}</div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.watch_times_avg }}
            <!-- <count-to :startVal="0"
              :endVal="mainKeyData.watch_times_avg"
              :duration="1500"
              v-if="mainKeyData.watch_times_avg >= 0">
            </count-to> -->
          </h3>
        </div>
      </vh-col>
      <!--      <vh-col :span="colSpan" v-if="pageType==='dataInfo'">-->
      <!--        <div class="grid-content">-->
      <!--          <span>{{ $t('lang.k_048027') }}</span>-->
      <!--          <vh-tooltip effect="dark" placement="right" v-tooltipMove>-->
      <!--            <div slot="content" v-if="!titleType">-->
      <!--              筛选条件内的观看总时长，将活动数据进行相加，数据不去重-->
      <!--            </div>-->
      <!--            <div slot="content" v-else>筛选条件内的观看总时长</div>-->
      <!--            <i class="iconfont-v3 saasicon_help_m"></i>-->
      <!--          </vh-tooltip>-->
      <!--          <h3 class="custom-font-barlow">-->
      <!--            {{ mainKeyData.watch_duration }}-->
      <!--          </h3>-->
      <!--        </div>-->
      <!--      </vh-col>-->
    </vh-row>
    <vh-row type="flex" class="row-bg bg-purple">
      <vh-col :span="colSpan">
        <div class="grid-content">
          <span>{{ $t('lang.k_048027') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content" v-if="!titleType">{{ $t('lang.k_048028') }}</div>
            <div slot="content" v-else>{{ $t('lang.k_048029') }}</div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.watch_duration }}
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan">
        <div class="grid-content">
          <span>{{ $t('lang.k_048030') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content" v-if="!titleType">{{ $t('lang.k_048031') }}</div>
            <div slot="content" v-else>
              {{ $t('lang.k_048032') }}
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.watch_duration_avg }}
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType == 1 || pageType === 'dataInfo'">
        <div class="grid-content">
          <span>{{ $t('lang.k_048033') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048034') }}
              <template v-if="pageType !== 'dataInfo'">；</template>
              <template v-if="pageType === 'dataInfo'">
                <!--自2023年8月20日开始统计-->
              </template>
              <template v-else>
                {{ $t('lang.k_048035') }}
                <br />
                {{ $t('lang.k_048036') }}
              </template>
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.live_watch_number }}
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType == 1 || pageType === 'dataInfo'">
        <div class="grid-content">
          <span>{{ $t('lang.k_048037') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048038') }}
              <template v-if="pageType !== 'dataInfo'">；</template>
              <template v-if="pageType === 'dataInfo'">
                <!-- 自2023年8月20日开始统计-->
              </template>
              <template v-else>
                {{ $t('lang.k_048035') }}
                <br />
                {{ $t('lang.k_048039') }}
              </template>
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.vod_watch_number }}
          </h3>
        </div>
      </vh-col>
      <vh-col :span="colSpan" v-if="titleType == 1">
        <div class="grid-content">
          <span>{{ $t('lang.k_048040') }}</span>
          <vh-tooltip effect="dark" placement="right" v-tooltipMove>
            <div slot="content">
              {{ $t('lang.k_048041') }}
              <!--              <template v-if="pageType==='dataInfo'">-->
              <!--                自2023年8月15日开始统计-->
              <!--              </template>-->
              <!--              <template v-else>-->
              <br />
              {{ $t('lang.k_048042') }}
              <br />
              {{ $t('lang.k_048043') }}
              <!--              </template>-->
            </div>
            <i class="iconfont-v3 saasicon_help_m"></i>
          </vh-tooltip>
          <h3 class="custom-font-barlow">
            {{ mainKeyData.total_watch_number }}
          </h3>
        </div>
      </vh-col>
    </vh-row>
  </div>
</template>
<script>
  import CountTo from 'vue-count-to';
  export default {
    props: {
      titleType: {
        type: Number,
        default: 0
      },
      highData: {
        type: Number,
        default: 0
      },
      mainKeyData: {
        type: Object
      },
      pageType: {
        // 调用页面类型
        type: String,
        default: ''
      }
    },
    components: {
      CountTo
    },
    data() {
      return {
        colSpan: 6
      };
    },
    created() {
      console.log(this.titleType, 23234432534535);
      this.colSpan = ['/data/info'].includes(this.$route.path) ? 5 : 4;
    }
  };
</script>
<style lang="less" scoped>
  .main_data {
    padding: 24px 32px;
    background: #fff;
    border-radius: 4px;
    .main_header {
      text-align: left;
      padding: 12px 0 18px 12px;
      p {
        height: 26px;
        font-size: 16px;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 26px;
        margin: 0;
      }
    }
    .row-bg {
      margin: 12px 28px 64px 28px;
    }
    .bg-purple {
      margin-bottom: 26px;
    }
    .activeJustify {
      justify-content: space-around;
    }
    .grid-content {
      text-align: left;
      > span {
        font-size: 14px;
        color: #999;
        margin: 0;
      }
      i {
        font-size: 14px;
        padding: 0 2px;
      }
      h3 {
        padding-top: 6px;
        font-size: 28px;
        font-weight: bold;
        color: #1a1a1a;
        span {
          font-size: 28px;
          font-weight: bold;
          color: #1a1a1a;
          margin: 0;
        }
      }
    }
  }
  ::v-deep .saasicon_help_m {
    color: #999999;
  }
</style>
